import type { Partner } from "@stockline/shared/types/crm/partner"
import type { OfflineResourceConfig } from "../../../types"
import { PARTNER_TABLE } from "./db"

export const partnerConfig: OfflineResourceConfig<Partner> = {
  name: "partners",
  // Catalogue-bound tenants pull all partners as `reference` on cold start.
  // 3000/page cuts the request count on large tenants (~503KB→~1.5MB decoded
  // per page, under the API's served ceiling); small tenants stay 1 page.
  // STK-1960.
  pageSize: 3000,
  endpoints: {
    full: "/api/v2/partners",
    delta: "/api/v2/partners/changes",
    push: "/api/v2/partners/changes",
  },
  tableName: PARTNER_TABLE,
  primaryKey: "id",
  indexes: {
    companyId: "companyId",
    type: "type",
    isActive: "isActive",
  },
  applyChange: (local, patch) => ({ ...local, ...patch }),
}
